import type { KoshCatalogStatus } from '@/types/catalogs';

/** Forward lifecycle actions for DRAFT→ACTIVE→DEPRECATED→ARCHIVED catalogs
 *  (price books, rate cards). */
export const CATALOG_ACTIONS: Partial<
  Record<KoshCatalogStatus, { to: KoshCatalogStatus; label: string }[]>
> = {
  DRAFT: [
    { to: 'ACTIVE', label: 'Activate' },
    { to: 'ARCHIVED', label: 'Archive' },
  ],
  ACTIVE: [
    { to: 'DEPRECATED', label: 'Deprecate' },
    { to: 'ARCHIVED', label: 'Archive' },
  ],
  DEPRECATED: [
    { to: 'ACTIVE', label: 'Reactivate' },
    { to: 'ARCHIVED', label: 'Archive' },
  ],
};
